import { apiRequest } from "../util/apiUtils";

export const roleList = async (params) => {
  try {
    const res = await apiRequest("get", `role/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const roleAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `role/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const roleDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `role/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const roleStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `role/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const roleDetails = async (payload) => {
  try {
    const res = await apiRequest("get", `/role/detail/${payload?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};